import { paths } from '@/core/router/paths';

import styles from './RootError.module.css';

export const RootError = () => (
	<div className={styles.root}>
		<span>Something went wrong.</span>
		<div className={styles.actions}>
			<button onClick={() => (window.location.href = paths.home)}>Home</button>
		</div>
	</div>
);
